import { Modal } from '@sapiens/insured-component-library';
import styled from 'styled-components';
import { Button } from '@sapiens/insured-component-library';
import { MediaBreakpoints, spacing } from 'common/utils/helpers/theme.helpers';

export const ConfirmationModal = styled(Modal)`
  .rc-dialog-content {
    width: 550px;
    min-height: fit-content;
    padding-bottom: 2rem;
  }
  .rc-dialog-content .rc-dialog-body {
    ::-webkit-scrollbar {
      width: 12px !important;
    }
    ::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.palette.neutral.white};
      border-radius: 6px;
    }
    ::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.palette.product.F999};
      border-radius: 20px;
      border: 3px solid ${({ theme }) => theme.palette.neutral.white};
    }
  }
  ${MediaBreakpoints.down('md')} {
    .rc-dialog-content {
      width: 90% !important;
      max-height: 513px;
    }
  }
`;
export const ConfirmationModalYes = styled(Button)`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.neutral.white};
  cursor: pointer;
  font-size: 14px;
  min-width: 15%;
  width: fit-content;
`;

export const ConfirmationModalNo = styled(Button)`
  font-weight: 600;
  background: ${({ theme }) => theme.palette.light.N30};
  color: ${({ theme }) => theme.palette.neutral.black};
  cursor: pointer;
  font-size: 14px;
  min-width: 15%;
  width: fit-content;
  &:hover {
    background: ${({ theme }) => theme.palette.light.N40};
  }
  &:active {
    background: ${({ theme }) => theme.palette.light.N20};
    color: ${({ theme }) => theme.palette.neutral.black};
  }
`;

export const ConfirmationModalContent = styled.div`
  padding: 12px;
  margin-top: ${spacing(9)};
  font-weight: 600;
  text-align: center;
  white-space: pre-line;
`;

export const ConfirmationButtonContainer = styled.div`
  margin-top: ${spacing(4)};
  display: flex;
  justify-content: center;
  gap: ${spacing(3)};
  ${MediaBreakpoints.down('md')} {
    margin-top: ${spacing(1)};
  }
`;
